import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/Relatorio";

/**
 * Classe de gerenciamento de chamadas da API dos módulos
 *
 * @class
 */
export default class ModuleApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe ModuleApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * @returns Lista de módulos da backend
   */
  list() {
    return this.api<ApplicationModule[]>(`${controller}/GetListarAplicacoes`, {
      method: "GET",
    });
  }

  /**
   * @returns Lista de módulos do backend filtrado pelos módulos que possuem relatório
   */
  listWithReport() {
    return this.api<ApplicationModule[]>(
      `${controller}/GetListarAplicacoesComRelatorio`,
      {
        method: "GET",
      },
    );
  }
}
